import { render, staticRenderFns } from "./UpdateRequestDetail.vue?vue&type=template&id=02d1716e&scoped=true&"
import script from "./UpdateRequestDetail.vue?vue&type=script&lang=js&"
export * from "./UpdateRequestDetail.vue?vue&type=script&lang=js&"
import style0 from "./update-request-detail.css?vue&type=style&index=0&id=02d1716e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d1716e",
  null
  
)

export default component.exports